// FIXME This file need refactor and has technical depth

import { connect, useDispatch } from "react-redux";
import { Select, Modal } from "antd";
import { Note } from "../../../../../helbest";
import { set_services_user_car } from "../../../../../store/actions/services_actions";
import CreateOrEditCar from "../SelectNewCar/SelectNewCar";

// icons
import { ReactComponent as BottomArrow } from "../../../../../assets/svg/up-down-arrow.svg";
import IconCar from "../../../../../assets/svg/car-service.svg";
import { useEffect, useRef, useState } from "react";
import { API } from "../../../../../request/api";
import { useTranslation } from "react-i18next";
import { formatCarDisplay } from "../../../../../base/utils";



const SelectCar = ({
  isVehicleSelected,
  closeModal,
  setSelectNewVehicle,
  userCars,
  selectedUserCar,
  setSelectedUserCar,
  mobileNumber,
  setMustRefetchUserInfo,
}) => {
  const dispatch = useDispatch();
  const [addingNewCar, setAddingNewCar] = useState(null);
  const [selectedUserCarInfo, setSelectedUserCarInfo] = useState(null);
  const yearRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const carInfo = userCars.find(
      (selectedCar) =>
        selectedCar.user_car_id ===
        selectedUserCar?.userCarSelected?.user_car_id
    );
    setSelectedUserCarInfo(carInfo);

    if (carInfo) {
      yearRef.current = carInfo.year;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserCar, userCars]);

  const clearData = () => {
    setSelectedUserCar((prevState) => ({
      ...prevState,
      userCarSelected: {
        user_car_id: null,
        user_car_name: "",
      },
      typeSelected: {
        type_id: null,
        type_name: "",
      },
      brandSelected: {
        brand_id: null,
        brand_name: "",
      },
      modelSelected: {
        model_id: null,
        model_name: "",
      },
      yearSelected: null,
    }));
  };

  const submitUserCar = () => {
    if (!addingNewCar) {
      // EXISTING CAR SELECTION
      const selectedCarName =
        selectedUserCarInfo?.user_model_name || selectedUserCarInfo?.model_name || "";
      const selectedCarBrand =
        selectedUserCarInfo?.brand_name || selectedUserCarInfo?.brand || "";

      // Update existing car
      if (selectedUserCarInfo?.year !== yearRef.current) {
        API.put
          .userCar(selectedUserCarInfo?.user_car_id, selectedUserCarInfo?.year)
          .then((response) => {
            if (response.success) {
             Note.success(t("new_service.user_car_edited_successfully"));
              dispatch(
                set_services_user_car(
                  selectedUserCarInfo.user_car_id,
                  selectedCarName,
                  selectedUserCarInfo.year,
                  selectedCarBrand
                )
              );
            } else {
              Note.error(t("error_boundary.message"));
            }
          })
          .catch((error) => console.log("Error : ", error));
      }

      dispatch(
        set_services_user_car(
          selectedUserCarInfo.user_car_id,
          selectedCarName,
          selectedUserCarInfo.year,
          selectedCarBrand
        )
      );
    } else {
      // NEW CAR CREATION
      API.post
        .userCar(
          selectedUserCar.modelSelected.model_id,
          selectedUserCar.yearSelected,
          mobileNumber
        )
        .then((response) => {
          if (response.success) {
            Note.success(t("new_service.new_car_added_successfully"));
            dispatch(
              set_services_user_car(
                response.data?.user_car_id,
                selectedUserCar.modelSelected.model_name,
                selectedUserCar.yearSelected,
                selectedUserCar.brandSelected.brand_name
              )
            );
          } else {
              Note.error(t("error_boundary.message"));
          }
        })
        .catch((error) => console.log(error.message));
    }
    setMustRefetchUserInfo(true);
    setAddingNewCar(null);
    clearData();
    closeModal();
  };

  return (
    <Modal
      open={isVehicleSelected}
      title={
        <div className="flex flex-column center-content icon_modal_my_new_car center column mt-5">
          <img className="cars-modal-icon" src={IconCar} alt="car" />
          <label>{t("new_service.select_car_modal.title")}</label>
        </div>
      }
      okText={t("common.submit")}
      cancelText={t("common.close")}
      okButtonProps={{
        className: "flex-stretch",
        disabled: addingNewCar ? !selectedUserCar?.yearSelected : false,
      }}
      footer={(_, { OkBtn, CancelBtn }) => (
        <div className="flex gap-2">
          <CancelBtn />
          <OkBtn />
        </div>
      )}
      onOk={() => submitUserCar()}
      onCancel={() => {
        setSelectNewVehicle(true);
        setMustRefetchUserInfo(true);
        setAddingNewCar(null);
        closeModal();
      }}
      cancelButtonProps={{
        className: "flex-stretch",
        type: "primary",
        danger: true,
        ghost: true,
      }}
    >
      <div className="flex column">
        <div className="create_car_box flex column center">
          <div className="select_box col12">
            <Select
              dir="ltr"
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder={t("new_service.select_car_modal.placeholder")}
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={
                selectedUserCar.userCarSelected.user_car_id ||
                t("new_service.select_car_modal.placeholder")
              }
              onChange={(value, option) => {
                if (value === "new") {
                  setAddingNewCar(true);
                  setSelectedUserCarInfo(null);
                  clearData();
                  setSelectedUserCar((prevState) => ({
                    ...prevState,
                    userCarSelected: {
                      user_car_id: null,
                      user_model_name: "",
                    },
                  }));
                } else {
                  setAddingNewCar(false);
                  setSelectedUserCar((prevState) => ({
                    ...prevState,
                    userCarSelected: {
                      user_car_id: value,
                      user_model_name: option.children,
                    },
                  }));
                }
              }}
            >
              {userCars.map((car) => (
                <Select.Option
                  className="dir-rtl"
                  value={car.user_car_id}
                  key={car.user_car_id}
                  title={formatCarDisplay(car.brand_name, car.model_name, car.year , 10)}
                >
                  {formatCarDisplay(car.brand_name, car.model_name, car.year , 10)}
                </Select.Option>
              ))}
              {
                <Select.Option value={"new"}>
                  {t("new_service.select_car_modal.add_car")}
                </Select.Option>
              }
            </Select>
          </div>

          {addingNewCar === true && (
            <CreateOrEditCar
              selectedUserCar={selectedUserCar}
              setSelectedUserCar={setSelectedUserCar}
              closeModal={() => setSelectNewVehicle(false)}
              isAddingNewCar={addingNewCar}
              selectedUserCarInfo={selectedUserCarInfo}
              setSelectedUserCarInfo={setSelectedUserCarInfo}
            />
          )}
          {addingNewCar === false && (
            <CreateOrEditCar
              selectedUserCar={selectedUserCar}
              setSelectedUserCar={setSelectedUserCar}
              closeModal={() => setSelectNewVehicle(false)}
              isAddingNewCar={addingNewCar}
              selectedUserCarInfo={selectedUserCarInfo}
              setSelectedUserCarInfo={setSelectedUserCarInfo}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(SelectCar);